export function formatBlocoQuadra(
  numero?: string,
  blocoQuadra?: string | null,
  prefix = "Unidade"
) {
  if (!numero) {
    return `${prefix + " "}--`;
  }
  const _numero = numero.toLowerCase().startsWith("unidade")
    ? numero
    : `${prefix.length > 0 ? prefix + " " : ""}${numero}`;
  return `${blocoQuadra ? blocoQuadra + ", " : ""}${_numero}`;
}
